import axios from 'axios';
import { baseUrl, ClientID, SecretKey } from '../Pages/ApiCommonService';
import { logout } from '../../LoginConfig/AdalConfig';

export const expTokenProcessAndGenerate = async (token: any) => {
    let localStorageToken = localStorage.getItem("adal.idtoken");
    let sessionToken = sessionStorage.getItem("token");
    if (!token && !localStorageToken) {
        console.error("No token available in both the passed token and localStorage.");
        return null;
    }

    if (token) {
        const decodedToken = token ? JSON.parse(atob(token?.split(".")[1])) : null;
        const decodedSessionToken = sessionToken ? JSON.parse(atob(sessionToken?.split(".")[1])) : null;
        if (decodedToken && decodedToken?.exp && new Date((decodedToken?.exp * 1000) - 100000) >= new Date()) {
            return token;
        } else if (decodedSessionToken && decodedSessionToken?.exp && new Date((decodedSessionToken?.exp * 1000) - 100000) >= new Date()) {
            return sessionToken;
        }
    }

    token = localStorageToken || token;

    try {
        const response = await axios.get(`${baseUrl}api/Authentication/LoginUser`, {
            params: { token }
        });

        if (response.status === 200 && response.data) {
            const newCustomToken = response.data;
            sessionStorage.setItem("token", newCustomToken);
            sessionStorage.setItem("sessionFlag", "true");
            return newCustomToken;
        } else {
            console.error("Unexpected response from backend.");
        }
    } catch (error: any) {
        if (error?.response?.data?.detail === "403: Deactivated User login") {
            console.warn("User is deactivated. Logging out...");
            logout();
        } else {
            console.error("Error during authentication request:", error);
        }
    }
    return null;
};

// -----------------****Api Calls for validate user login(Validate userlogin option, forget/reset psd)****-------------//


export const UserLoginTriggerandTokenSet = async (UserName: string, Password: string) => {
    try {
        const response = await axios.post(
            `${baseUrl}api/Authentication/userLogin?UserName=${encodeURIComponent(UserName)}&Password=${Password}`,
            null,
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        if (response.status === 200 || response.status === 201) {
            return response.data;
        }
    } catch (error) {
        console.error('Error in generating token:', error);
        throw error;
    }
};

export const resetPassword = async (user: any) => {
    try {
        const response = await axios.post(baseUrl + "api/Authentication/forgetPassword", user, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response?.status === 200) {
            return response?.data;
        }
        return response
    } catch (error) {
        console.error("Error ", error);
        throw error;
    }
};

// ----------------------------------------------------------------------------------------------------------------//
